import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import React, { useEffect } from "react";
import Menu from './components/Menu';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Customer from './pages/Customer';
import Bill from './pages/Bill';
import Visit from './pages/Visit';
import CustomerProfile from './pages/CustomerProfile';
import CustomerFollowUp from './pages/CustomerFollowUp';
import { Plugins, Capacitor, registerPlugin } from "@capacitor/core";
import { Provider } from "react-redux";
import { Store } from "./data/state/Store";
import { StatusBar  } from '@capacitor/status-bar';
import CheckPermissions from './services/Permission';
import { BackgroundGeolocationPlugin } from '@capacitor-community/background-geolocation';
import { SplashScreen } from "@capacitor/splash-screen";
import So from './pages/So';
import Echo from './services/Echo';
import { LocalNotifications } from "@capacitor/local-notifications";
import AuthProvider from "./data/sessions/Auth";

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.scss';
import "./App.scss";
import { Preferences } from '@capacitor/preferences';
import { useConstructor } from './services/Library';
import Item from './pages/Item';

setupIonicReact({ mode: "md" , hardwareBackButton: true});

export const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation");

const listRoute = [
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/customer",
    component: Customer,
  },
  {
    path: "/customer_profile",
    component: CustomerProfile,
  },
  {
    path: "/bill",
    component: Bill,
  },
  {
    path: "/visit",
    component: Visit,
  },
  {
    path: "/so",
    component: So,
  },
  {
    path: "/item",
    component: Item,
  },
  {
    path: "/customer_follow_up",
    component: CustomerFollowUp,
  },
];


const App: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const { value } = await Preferences.get({ key: "auth" });
      Echo.channel("notify").listen("NotifyEvent", async (event: any) => {
        await LocalNotifications.schedule({
          notifications: [
            {
              title: event.notify.title,
              body: event.notify.body,
              id: new Date().getTime(),
            },
          ],
        });
      });
      if (value) {
        Echo.channel(value).listen("NotifyEvent", async (event: any) => {
          await LocalNotifications.schedule({
            notifications: [
              {
                title: event.notify.title,
                body: event.notify.body,
                id: new Date().getTime(),
              },
            ],
          });
        });
      }
    })();
    if (Capacitor.isNative) {
      Plugins.App.addListener(
        "backButton",
        (e: any) => {
          if (
            window.location.pathname === "/home" ||
            window.location.pathname === "/login"
          ) {
            Plugins.App.exitApp();
          } else {
            history.goBack();
          }
        },
        { capture: true }
      );
    }
  }, [history]);

  useConstructor(async () => {
    if (Capacitor.isNative) {
      CheckPermissions.requestFineLocation();
      CheckPermissions.requestCameraPermission();
      CheckPermissions.requestFilesystem();
      await StatusBar.show();
      await SplashScreen.hide();
    }
  });

  return (
    <Provider store={Store}>
      <AuthProvider>
        <IonApp>
            <IonReactRouter>
              <Menu />
              <IonSplitPane contentId="main">
                <IonRouterOutlet id="main">
                  <Switch>
                    {listRoute.map((val, key) => (
                      <Route
                        key={key}
                        path={val.path}
                        component={val.component}
                        exact
                      />
                    ))}
                    <Redirect from="/" to="/home" exact />
                  </Switch>
                </IonRouterOutlet>
              </IonSplitPane>
            </IonReactRouter>
        </IonApp>
      </AuthProvider>
    </Provider>
  );
};

export default App;
